module.exports = __webpack_public_path__ + "static/media/Logo.2409a0f2.png";